import { isSSR } from '.';

type GetValueFromLocalStorage = Nullable<string>;

type SetValueInLocalStorageParams = {
	id: string;
	value: string;
};

export const getValueFromLocalStorage = (id: string): GetValueFromLocalStorage => {
	if (isSSR()) {
		return null;
	}

	return window.localStorage.getItem(id);
};

export const setValueInLocalStorage = ({ id, value }: SetValueInLocalStorageParams): void => {
	if (isSSR()) {
		return;
	}

	window.localStorage.setItem(id, value);
};
